// extracted by mini-css-extract-plugin
export var root = "SizeList-module--root--d1877";
export var sizeLabelContainer = "SizeList-module--sizeLabelContainer--21099";
export var sizeSelection = "SizeList-module--sizeSelection--45655";
export var guide = "SizeList-module--guide--b935e";
export var label = "SizeList-module--label--44881";